import React, { JSX, useContext } from 'react';
import { Routes } from '../../app/Routes';
import { localized } from '../../config/localization';
import { AuthContext, AuthContextProps } from '../../services/AuthContext';
import { Button } from '../../components/Button/Button';
import { BlankPage } from '../../components/BlankPage/BlankPage';
import { Navigate, useNavigate } from 'react-router';
import { readVisitedFlag } from '../WelcomePage/visitedFlag';

export function WaitingForApprovalPage(): JSX.Element {
  const navigate = useNavigate();
  const { refreshUser, user } = useContext<AuthContextProps>(AuthContext);

  if (!readVisitedFlag(user?.email ?? 'anonymous')) {
    return <Navigate to={Routes.WELCOME_PAGE} />;
  }

  return (
    <BlankPage title={localized.WAIT_FOR_CONFIRMATION}>
      <BlankPage.Buttons>
        <Button onClick={() => refreshUser().then(() => navigate(Routes.WELCOME_PAGE))}>{localized.RETRY}</Button>
      </BlankPage.Buttons>
    </BlankPage>
  );
}
